import React from 'react';
import PostItem from './post-item'

class PostsList extends React.Component {

	render() {

		const defaultCssClass = 'post-list';
		let cssClass = this.props.cssClass ? defaultCssClass + ' ' + this.props.cssClass : defaultCssClass;

		return (
			<ul className={cssClass}>
				{this.props.data.map((post, index) =>
					<PostItem key={post.id} data={post} index={index} full={this.props.full} />
				)}				
			</ul>

		);
	}
}	

export default PostsList;